<template>
  <sweet-modal ref="user_modal" :title="(is_new ? 'add_user' : 'edit_user') | t" blocking="blocking">
    <div v-if="user">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>{{ 'first_name' | t }}</label>
            <input class="form-control" v-model="user.first_name" />
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>{{ 'last_name' | t }}</label>
            <input class="form-control" v-model="user.last_name" />
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>{{ 'email' | t }}</label>
        <input class="form-control" v-model="user.email" type="email" />
      </div>
      <div class="form-group">
        <label>{{ 'user_group' | t }}</label>
        <select class="form-control" v-model="user.user_group">
          <option v-for="group in user_groups" :value="group">{{ group.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>{{ 'locale' | t }}</label>
        <select class="form-control" v-model="user.locale">
          <option v-for="l in ['da', 'en']" :value="l">{{ l }}</option>
        </select>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          id="user-all-order-channels"
          type="checkbox"
          v-model="user.all_order_channels"
        />
        <label class="form-check-label" for="user-all-order-channels">{{ 'all_order_channels' | t }}</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" id="user-all-carriers" type="checkbox" v-model="user.all_carriers" />
        <label class="form-check-label" for="user-all-carriers">{{ 'all_carriers' | t }}</label>
      </div>
      <div class="form-group">
        <button class="d-block ml-auto btn btn-lg btn-success" @click="save_or_update">
          {{ (is_new ? 'create' : 'update') | t }}
        </button>
      </div>
    </div>
  </sweet-modal>
</template>
<script>
import _ from 'lodash';
import Api from '@/store/clientapi';
import Alerts from '@/utils/alerts';

var _user = () => ({
  first_name: '',
  last_name: '',
  email: ''
});

export default {
  props: ['title'],
  data: function () {
    return {
      user: null,
      password_repeat: null,
      user_groups: [],
      _orig: null
    };
  },
  computed: {
    is_new: function () {
      return !(this.user && this.user.id);
    }
  },
  methods: {
    open: function (user) {
      if (user === void 0) {
        user = _user();
      } else {
        this._orig = user;
        user = _.cloneDeep(user);
      }

      console.log('find all user grous');
      Api.findAll('user_groups').then(({ data }) => {
        console.log(data);
        this.user_groups = data;
        console.log(this.user_groups);
        if (this.user_groups.length > 0 && !this.user.id) this.user.user_group = this.user_groups[0];
      });

      this.user = user;
      this.$refs.user_modal.open();
    },
    close: function () {
      this.$refs.user_modal.close();
    },
    save_or_update: function () {
      if (this.user.id) {
        this.update();
      } else {
        this.save();
      }
    },
    save: function () {
      Api.create('users', this.user)
        .then(({ data }) => {
          data.is_new = true;
          Alerts.success({ title: 'Created', detail: 'New user added' });
          this.$emit('done', this.user);

          if (this._orig) {
            Object.assign(this._orig, this.user);
          }
          this.$refs.user_modal.close();
        })
        .catch(({ errors }) => {
          errors.forEach((err) => {
            Alerts.danger(err);
          });
        });
    },
    update: function () {
      Api.update('users', this.user)
        .then(({ data }) => {
          data.is_updated = true;
          Alerts.success({ title: 'Updated', detail: 'User updated' });

          this.$emit('userCreated', this.user);
          if (this._orig) {
            Object.assign(this._orig, this.user);
          }
          this.$refs.user_modal.close();
        })
        .catch(({ errors }) => {
          errors.forEach((err) => {
            Alerts.danger(err);
          });
        });
    }
  }
};
</script>

<style scoped></style>
